export const stopPropagation = (e: React.MouseEvent<HTMLSpanElement>): void => {
  e.stopPropagation();
};
